import React from 'react';
import { ProgressBar } from 'react-bootstrap';

const ProgressBarComponent = ({ formSection }) => {
  const sections = ['personal', 'contact', 'address', 'insurance'];
  const currentIndex = sections.indexOf(formSection);
  const progressPercentage = ((currentIndex + 1) / sections.length) * 100;

  return (
    <div className="mb-4">
      <div className="d-flex justify-content-between small text-muted mb-1">
        <span>Personal Info</span>
        <span>Contact</span>
        <span>Address</span>
        <span>Insurance</span>
      </div>
      <ProgressBar now={progressPercentage} />
    </div>
  );
};

export default ProgressBarComponent;